import { attr, FASTElement, observable } from '@microsoft/fast-element';
import { formFieldStyles } from './form-field.styles';
import { formFieldTemplate } from './form-field.template';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { uniqueId } from '@microsoft/fast-web-utilities';

/**
 * @element natgen-form-field
 */
export class NatGenFormField extends FASTElement {
    @attr label: string;
    @attr orientation: 'center' | 'left' | 'right' = 'left';
    // TODO: Allow for control of tooltip placement?
    @observable slottedTooltipNodes: Node[];

    @observable slottedLabelNodes: Element[];
    public slottedLabelNodesChanged(
        oldValue: Element[],
        newValue: Element[]
    ): void {
        if (this.$fastController.isConnected) {
            this.associateLabel();
        }
    }

    @observable slottedValidationNodes: Element[];
    public slottedValidationNodesChanged(
        oldValue: Element[],
        newValue: Element[]
    ): void {
        if (this.$fastController.isConnected) {
            this.associateValidation();
        }
    }

    @observable slottedControlNodes: Element[];
    public slottedControlNodesChanged(
        oldValue: Element[],
        newValue: Element[]
    ): void {
        if (this.$fastController.isConnected) {
            this.associateLabel();
            this.associateValidation();
        }
    }

    protected associateLabel() : void {
        const control = this.slottedControlNodes?.find(n => n instanceof Element) as Element;

        if (this.slottedLabelNodes.length && control) {
            this.slottedLabelNodes.forEach(label => {                
                label.id = label.id || uniqueId('label-');
            });
            
            control.id = control.id || uniqueId('control-');
            control.setAttribute('aria-labelledby', this.slottedLabelNodes.map(n => n.id).join(' '));
        }
    }

        public handleLabelClick(): void {
            const control = this.slottedControlNodes?.find(n => n instanceof Element) as HTMLElement | undefined;
            control?.focus();
        }

    protected associateValidation() : void {
        const control = this.slottedControlNodes?.find(n => n instanceof Element) as Element;

        if (control && this.slottedValidationNodes?.length) {
            const describedByIds: string[] = [];

            this.slottedValidationNodes.forEach((node, index) => {
                node.id = node.id || uniqueId('validation-');
                describedByIds.push(node.id);
            });

            control.setAttribute('aria-describedby', describedByIds.join(' '));
        }
    }
}

export const natGenFormFieldDefinition = NatGenFormField.compose({
    name: `${NatGenDesignSystem.prefix}-form-field`,
    template: formFieldTemplate,
    styles: formFieldStyles
});
